import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_HeaderDetailContent0 = _resolveComponent("HeaderDetailContent0")!
  const _component_HeaderDetailContent1 = _resolveComponent("HeaderDetailContent1")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('header'),
        "back-route": {name: 'headers'},
        mode: _ctx.PageDetailModeEnum.EDIT,
        "help-text": "Voorbeeld van een helptekst.",
        mb: 3
      }, null, 8, ["title", "mode"]),
      (_ctx.type === _ctx.HeaderContentTypeEnum.HEADER_CONTENT_0)
        ? (_openBlock(), _createBlock(_component_HeaderDetailContent0, {
            key: 0,
            id: _ctx.id,
            type: _ctx.type
          }, null, 8, ["id", "type"]))
        : _createCommentVNode("", true),
      (_ctx.type === _ctx.HeaderContentTypeEnum.HEADER_CONTENT_1)
        ? (_openBlock(), _createBlock(_component_HeaderDetailContent1, {
            key: 1,
            id: _ctx.id,
            type: _ctx.type
          }, null, 8, ["id", "type"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}